import bar from './bar/bar'
import funnel from './funnel/funnel'
import line from './line/line'
import pictorialBar from './pictorialBar/pictorialBar'
import pie from './pie/pie'
import radar from './radar/radar'
import scatter from './scatter/scatter'
import treemap from './treemap/treemap'

export default {
  type: "typeArray",
  name: "series",
  nickname: "图表",
  desc: "",
  value: [],
  defaultValue: [],
  isExpandForce: true,
  props: {
    bar,
    funnel,
    line,
    pictorialBar,
    pie,
    radar,
    scatter,
    treemap,
  },
  menuIconType: "text",
  menuIcon: "TB",
}
